import _ from 'underscore';
import React, { useCallback, useMemo } from 'react';
import { Tags } from '@bingads-webui-fluent-component/tags';
import { useDataSelection } from '@bingads-webui-react/data-selection';

import { I18n } from '../types';

interface SelectionTagsProps {
  i18n: I18n;
  tagViewLimit?: number;
  onRenderTagContent?: (tag: any) => React.ReactNode;
}

export const SelectionTags: React.FC<SelectionTagsProps> = ({
  i18n,
  tagViewLimit,
  onRenderTagContent,
}) => {
  const { dataSelection, setDataSelection } = useDataSelection();

  const tagItems = useMemo(() => _.pluck(dataSelection, 'value'), [dataSelection]);

  const onChange = useCallback((newValues) => {
    const newSelection = _.filter(dataSelection, (item) => newValues.includes(item.value));

    setDataSelection(newSelection);
  }, [dataSelection, setDataSelection]);

  return (
    <Tags
      i18n={i18n}
      tagViewLimit={tagViewLimit}
      tagItems={tagItems}
      onRenderTagContent={
        onRenderTagContent
          ? (itemValue) => onRenderTagContent(dataSelection.find((item) => item.value === itemValue))
          : undefined
      }
      onChange={onChange}
    />
  );
};
